import * as React from 'react';
import './ToggleField.css';
import { Option, TOption } from '../../../../utils/Option';
import { Toggle, ToggleItem } from '@emorg-prd/standard-react';
import { Field } from '../../form-controls/Field';
import { IValidation } from '../../../../utils/Validation';

interface ToggleProps {
	id: string;
	onChange?: (...args: any[]) => any;
	options: TOption [];
	label: string;
	value: any;
	disabled?: boolean;
	note?: React.ReactNode;
	className?: string;
	validation?: IValidation;
}

const ToggleField: React.FC<ToggleProps> = (props) => {

	const abstractTextInput = new (class extends Field<ToggleProps> {
			constructor() {
				super(props);
			}
		})();

    const normalizedOptions: Option[] = React.useMemo(
        () => props.options.map(o => new Option(o)),
        [props.options]
    );
    
    return (
        <Toggle
            {...props}
            note={abstractTextInput.nonValidMessage() || props.note}
            optionalClass={`${!abstractTextInput.isValid() ? 'em-has-error' : props.value != null ? 'em-is-valid' : 'em-has-error'} ${props.className ?? ''} custom-toggle-field`}
            state={props.disabled ? 'em-is-disabled' : (!abstractTextInput.isValid() || props.value == null) ? 'em-has-error' : 'em-is-valid'}

        >
            {normalizedOptions.map((option: Option, index: number) => (
                <ToggleItem 
                    id={`${props.id || `toggle-${props.label.split(' ').join('')}`}-${index}`}
                    key={`${props.id || 'toggle'}-${option.value.toString()}`}
                    name={`${props.id || 'toggle'}-${index}`}
                    value={option.value}
                    onChange={props.onChange}
                    checked={props.value === option.value}
                    disabled={props.disabled}
                >
                    {option.text}
                </ToggleItem>
            ))}
        </Toggle>
	);
}

export { ToggleField };
